module.exports = __webpack_public_path__ + "img/shuilian3.7f495550.png";